/*
 * ****************************************************************
 * File: App.js
 * Project: CPaaS
 * Owner: Radisys
 *
 * Copyright - 2021 Radisys Corporation.
 * All rights reserved. No part of this software may be used or
 * reproduced in any form by any means without the prior written
 * permission of Radisys Corporation.
 *
 * Author: Pavan Kumar
 *
 * ****************************************************************
 */
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Home from "./pages/home/home";
import audioPlayer from "../src/components/audioPlayer";
import { useLocation } from "react-router-dom";
import Login from "./pages/login/login";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import Promo from "./pages/promovideo/promovideo";
import getCustomHeaderFromLocalstorage from "./helper/helper";
import Constant from "./helper/constant.json";
import axios from "axios";
// import getCustomHeaderFromLocalstorage from "./helper";
// Below commented line is for duplicate registration failed issue handling
//import { useHistory } from "react-router-dom";

const App = ({ test = false }) => {
  // Below commented line is for duplicate registration failed issue handling
  //const history = useHistory();
  const debugLogs = useRef([]);
  const engageClient = useRef(null);
  const engageRTCUtil = useRef(null);
  const ringingStatus = useRef(null);
  const transffered = useRef(null);
  const [remoteStream, _setRemoteStream] = useState(null);
  const remoteStreamRefApp = useRef(remoteStream);
  const [localStream, _setLocalStream] = useState(null);
  const localStreamRefApp = useRef(localStream);
  const [isLogged, setIsLogged] = React.useState(false);
  const [time, setTime] = useState(0);
  const [timeToLoad, setTimeToLoad] = React.useState(false);
  const [collocation, setCollocation] = React.useState("");
  const [conferenceLayout, setConferenceLayout] = React.useState(false);
  const [toggleTranscribe, setToggleTranscribe] = React.useState(false);
  // Below code is for duplicate registration failed issue handling
  // const [errorInfo, setErrorInfo] = React.useState({
  //   errorCode: 0,
  //   errorMessage: "",
  // });
  const [isBrowser, setIsBrowser] = useState(
    window.EngageDigital.isEngageDigitalWebrtcSupported()
  );

  const resolutionData = [
    {
      value: "QCIF",
      label: "QCIF - 144p",
      weight: 1,
    },
    {
      value: "LD",
      label: "LD - 240p",
      weight: 2,
    },
    {
      value: "SD",
      label: "SD - 480p",
      weight: 3,
    },

    {
      value: "HD",
      label: "HD - 720p",
      weight: 4,
    },
  ];

  const setRemoteStream = (data) => {
    remoteStreamRefApp.current = data;
    _setRemoteStream(data);
  };

  const setLocalStream = (data) => {
    localStreamRefApp.current = data;
    _setLocalStream(data);
  };

  const logoutClient = () => {
    /*
     *  Clean up the connection on disconnect.
     */
    if (engageClient.current !== null) {
      if (engageClient.current.isConnected()) {
        engageClient.current.disconnect();
        engageClient.current = null;
        setConnection({ ...connection, status: "Disconnected" });
        setTime(0);
      }
    }
    sessionStorage.removeItem("upgrade");
    sessionStorage.removeItem("joinmuted");
    localStorage.removeItem("time");
    onStopTranscribe()
  };

  const [remoteURI, setRemoteURI] = useState("");
  const [date] = useState(Date.now());
  const [callDate, setCallDate] = useState();
  const [connection, setConnection] = useState({
    connection: null,
    status: "Disconnected",
    identity: "",
    username: "",
  });

  const [session, setSession] = useState({
    session: null,
    remoteUser: "XYZ",
    remoteUserName: "ABC",
    incoming: false,
    ringing: false,
    constraints: { audio: true, video: true },
    upgrade: true,
  });
  const [readyEvent, setReadyEvent] = useState(false);
  const [upgrade, setUpgrade] = useState(false);

  // converting timestrap to date
  const newDate = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);

  // converting timestrap to callDuration
  const setLocalStreamHandler = (stream) => {
    const localStreamRef = document.getElementById("localStream");
    if (localStreamRef) {
      localStreamRef.srcObject = null;
      localStreamRef.srcObject = stream;
    } else {
      setLocalStream(stream);
    }
  };

  useEffect(() => {
    if (session.session !== null) {
      const ongoingSession = session.session;
      /**
       * To Handle all the exception
       */

      ongoingSession.addEventHandler("errorinfo", (error) => {
        console.log("Session-errorInfo:", error);
        toast.error(error.errorMessage);
      });
      ongoingSession.addEventHandler("connecting", () => {
        if (ringingStatus.current) {
          clearInterval(ringingStatus.current);
          ringingStatus.current = null;
        }
        debugLogs.current.push("Call: Connecting");
        toast.success("Connecting");
        ringingStatus.current = "connecting";
        console.log("Call: Connecting");
      });
      // }
      ongoingSession.addEventHandler("calltransferinitiated", ({ to }) => {
        const callTransfer = document.getElementById("message");
        if (callTransfer) {
          callTransfer.innerHTML = `Transferring Call to ${to}`;
          transffered.current = to;
        }
        toast.success(`calltransferinitiated ${to}`);
      });

      ongoingSession.addEventHandler("calltransfersucceeded", () => {
        const callTransfer = document.getElementById("message");
        if (callTransfer) {
          callTransfer.innerHTML = transffered.current;
          transffered.current = null;
        }
        toast.success("calltransfersucceeded");
      });

      ongoingSession.addEventHandler("failed", (e) => {
        if (ringingStatus.current) {
          clearInterval(ringingStatus.current);
          ringingStatus.current = null;
        }
        debugLogs.current.push(`Call: Failed, ${e.errorMessage}`);
        toast.error("Call Failed");
        toast.error(e.errorMessage);
        console.log("Call: Failed", e);
        setSession({
          ...session,
          session: null,
          incoming: false,
          ringing: false,
        });
        sessionStorage.removeItem("videoFlag");
      });

      ongoingSession.addEventHandler("disconnected", () => {
        if (ringingStatus.current) {
          clearInterval(ringingStatus.current);
          ringingStatus.current = null;
        }
        debugLogs.current.push("Call: Disconnected");
        toast.error("Call Disconnected");
        console.log("Call: Disconnected");
        setLocalStream(null);
        setRemoteStream(null);
        setSession({
          ...session,
          session: null,
          incoming: false,
          ringing: false,
        });
        sessionStorage.removeItem("videoFlag");
        onStopTranscribe()
      });

      ongoingSession.addEventHandler("collocation", () => {
        console.log("###### session", session);
        if (ringingStatus.current) {
          clearInterval(ringingStatus.current);
          ringingStatus.current = null;
        }
        debugLogs.current.push("Call: collocation");
        toast.info("Collocation");
        setLocalStream(null);
        setRemoteStream(null);
        setCollocation("collocation");
        setSession({
          ...session,
          session: null,
          incoming: false,
          ringing: false,
        });
        sessionStorage.removeItem("videoFlag");
      });
      ongoingSession.addEventHandler("peerdisconnected", () => {
        if (ringingStatus.current) {
          clearInterval(ringingStatus.current);
          ringingStatus.current = null;
        }
        debugLogs.current.push("Call: Peer Disconnected");
        toast.error("Peer Disconnected");
        console.log("Call: Peer Disconnected");
        setLocalStream(null);
        setRemoteStream(null);
        setSession({
          ...session,
          session: null,
          incoming: false,
          ringing: false,
        });
        sessionStorage.removeItem("videoFlag");
        onStopTranscribe()
      });
      ongoingSession.addEventHandler("connected", () => {
        if (ringingStatus.current) {
          clearInterval(ringingStatus.current);
          ringingStatus.current = null;
        }
        debugLogs.current.push("Call: Connected");
        toast.success("Call Connected");
        console.log("Call: Connected");
        setSession({
          ...session,
          ringing: false,
        });
      });
      ongoingSession.addEventHandler("remotestream", ({ stream }) => {
        const remoteStreamRef = document.getElementById("remoteStream");
        if (remoteStreamRef) {
          if (remoteStreamRef.srcObject !== null) {
            if (stream.getVideoTracks().length > 0) {
              stream.getVideoTracks()[0].enabled = false;
            }
            remoteStreamRef.onloadedmetadata = function () {
              const tracks = stream.getVideoTracks();

              for (let i = 0; i < tracks.length; ++i) {
                tracks[i].enabled = true;
              }
            };

            remoteStreamRef.srcObject = null;
            remoteStreamRef.srcObject = stream;
          } else {
            setRemoteStream(stream);
          }
        } else {
          setRemoteStream(stream);
        }
        debugLogs.current.push("Call: Remote Stream Added");
      });

      ongoingSession.addEventHandler("localstream", ({ stream }) => {
        if (remoteStreamRefApp.current) {
          setLocalStreamHandler(stream);
        } else {
          setLocalStream(stream);
        }
        debugLogs.current.push("Call: Local Stream Added");
      });

      ongoingSession.addEventHandler("upgradevideoaccessdenied", (event) => {
        /*
         *  When permission is not given, either remote or local party, then the event
         *  will be triggered
         */
        debugLogs.current.push(`Call: ${event.cause}`);
        toast.error(`Call: ${event.cause}`);
      });
    }
  }, [session.session]);

  const onSession = (engageSession) => {
    const constraints = engageSession._defaultCallParams.mediaConstraints;
    const calledTime = new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "numeric",
    }).format(callDate);
    if (engageSession.getOriginator() === "local") {
      debugLogs.current.push("Session: Outgoing Call in Progress");
      toast.info("Outgoing Call in Progress");
      console.log("Session: Outgoing Call in Progress");
      const constraints = engageSession.getCallParams()["mediaConstraints"];
      // Incoming Call
      const calls = localStorage.getItem("history");
      if (calls) {
        let itemData = {};
        const items = JSON.parse(calls);
        itemData = {
          uri: engageSession.getRemoteId()._uri._user,
          duration: calledTime,
          type: "outgoing",
          name: engageSession.getRemoteId()._display_name,
          call:
            engageSession.getOriginator() === "local"
              ? engageSession._callParams.mediaConstraints
              : { audio: true, video: engageSession.incomingCallWithVideo },
        };
        if (!items["Calllogs"][newDate]) {
          items["Calllogs"][newDate] = [];
        }
        items["Calllogs"][newDate].push(itemData);
        localStorage.setItem("history", JSON.stringify(items));
      } else {
        localStorage.setItem(
          "history",
          JSON.stringify({
            Calllogs: {
              [newDate]: [
                {
                  uri: engageSession.getRemoteId()._uri._user,
                  duration: calledTime,
                  type: "outgoing",
                  name: engageSession.getRemoteId()._display_name,
                  call:
                    engageSession.getOriginator() === "local"
                      ? engageSession._callParams.mediaConstraints
                      : {
                          audio: true,
                          video: engageSession.incomingCallWithVideo,
                        },
                },
              ],
            },
          })
        );
      }
      setSession({
        ...session,
        session: engageSession,
        ringing: true,
        incoming: false,
        remoteUser: engageSession.getRemoteId()._uri._user,
        remoteUserName: engageSession.getRemoteId()._display_name,
        constraints: constraints,
      });

      engageSession.addEventHandler("ringing", () => {
        audioPlayer.play("ringing");
        const ringing = setInterval(() => {
          if (
            engageSession?._callState === null ||
            engageSession?._callState === "connected"
          ) {
            clearInterval(ringing);
            ringingStatus.current == null;
            return;
          }
          audioPlayer.play("ringing");
        }, 3000);
        ringingStatus.current = ringing;
        debugLogs.current.push("Call: Ringing");
        console.log("Call: Ringing");
      });
      return;
    }

    /*
     *  If an incoming sesson is already active, then if another use is trying the same
     *  user, then that user would be returned with a response as 486
     */
    const calls = localStorage.getItem("history");
    const date = Date.now();
    const incommingTime = new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "numeric",
    }).format(date);
    if (calls) {
      let itemData = {};
      const items = JSON.parse(calls);
      itemData = {
        uri: engageSession.getRemoteId()._uri._user,
        duration: incommingTime,
        type: "incoming",
        name: engageSession.getRemoteId()._display_name,
        call:
          engageSession.getOriginator() === "remote"
            ? { audio: true, video: engageSession.incomingCallWithVideo }
            : engageSession._callParams.mediaConstraints,
      };
      if (!items["Calllogs"][newDate]) {
        items["Calllogs"][newDate] = [];
      }

      items["Calllogs"][newDate].push(itemData);
      localStorage.setItem("history", JSON.stringify(items));
    } else {
      localStorage.setItem(
        "history",
        JSON.stringify({
          Calllogs: {
            [newDate]: [
              {
                uri: engageSession.getRemoteId()._uri._user,
                duration: incommingTime,
                type: "incoming",
                name: engageSession.getRemoteId()._display_name,
                call:
                  engageSession.getOriginator() === "remote"
                    ? {
                        audio: true,
                        video: engageSession.incomingCallWithVideo,
                      }
                    : engageSession._callParams.mediaConstraints,
              },
            ],
          },
        })
      );
    }
    if (session.session !== null) {
      engageSession.rejectCall({
        status_code: 486,
        reason_phrase: "Busy Here",
      });
      return;
    }
    debugLogs.current.push("Session: Incoming Call Detected");
    // This is an incoming call and we require to listen to the various events
    setSession({
      ...session,
      session: engageSession,
      incoming: true,
      ringing: true,
      remoteUser: engageSession.getRemoteId()._uri._user,
      remoteUserName: engageSession.getRemoteId()._display_name,
      constraints: constraints,
    });

    engageSession.addEventHandler("ringing", () => {
      audioPlayer.play("ringing");
      const ringing = setInterval(() => {
        if (
          engageSession?._callState === null ||
          engageSession?._callState === "connected"
        ) {
          clearInterval(ringing);
          ringingStatus.current == null;
          return;
        }
        audioPlayer.play("ringing");
      }, 3000);
      ringingStatus.current = ringing;
      debugLogs.current.push("Call: Ringing");
      console.log("Call: Ringing");
    });
  };

  const makeCall = ({ audio, video, remoteURI }) => {
    debugLogs.current.push("Call: Call Make Action Triggered");
    console.log("Call: Call Make Action Triggered");

    if (remoteURI == "") {
      const calls = localStorage.getItem("history");
      if (calls) {
        const items = JSON.parse(calls);
        const reDialData = Object.values(items.Calllogs)[
          Object.keys(items.Calllogs).length - 1
        ];
        remoteURI = reDialData[reDialData.length - 1]["uri"];
        toast.info(`Redialling ${remoteURI}`);
        debugLogs.current.push("Call: Redialling- remoteURI");
        setRemoteURI(remoteURI);
      }
    }
    // This is an incoming call and we require to list
    if (engageClient.current !== null) {
      try {
        toast.info(
          `Call: Making a ${video ? "Video" : "Audio"} Call ${remoteURI}`
        );
        debugLogs.current.push(
          `Call: Making a ${video ? "Video" : "Audio"} Call to ${remoteURI}`
        );

        engageClient.current.makeCall(remoteURI, {
          mediaConstraints: {
            audio,
            video,
          },
          rtcOfferConstraints: {
            offerToReceiveAudio: audio ? 1 : 0,
            offerToReceiveVideo: video ? 1 : 0,
          },
          joinWithVideoMuted: true,
          customParams: getCustomHeaderFromLocalstorage(
            localStorage.getItem(Constant.LocalStorageCustomHeaderItem)
          ),
        });
      } catch (e) {
        console.log("Call: Making Call went into Exception", e.errorMessage);
        toast.error(`Call Failed : ${e.errorMessage}`);
        debugLogs.current.push(
          `Call: Making Call went into Exception, ${e.errorMessage}`
        );
      }
    }
  };
  const acceptCall = ({ audio }) => {
    /*
     * Accept a call when session is active and state is ringing
     */
    if (session.session && session.incoming && session.ringing) {
      debugLogs.current.push("Call: Accept Action Triggered");
      toast.info("Call Accept Action Triggered");
      console.log("Call: Accept Action Triggered");
      audioPlayer.stop("ringing");
      if (ringingStatus.current) {
        clearInterval(ringingStatus.current);
        ringingStatus.current = null;
      }
      const incomingSession = session.session;
      let acceptWithVideo = false;
      try {
        if (incomingSession.isIncomingCallWithVideo()) {
          acceptWithVideo = sessionStorage.getItem("videoFlag") !== "true";
        }
        incomingSession.acceptCall({
          mediaConstraints: {
            audio,
            video: acceptWithVideo,
          },
          rtcOfferConstraints: {
            offerToReceiveAudio: audio ? 1 : 0,
            offerToReceiveVideo: acceptWithVideo ? 1 : 0,
          },
          joinWithVideoMuted: true,
          customParams: getCustomHeaderFromLocalstorage(
            localStorage.getItem(Constant.LocalStorageCustomHeaderItem)
          ),
        });
      } catch (e) {
        console.log("Call: Accpeting Call went into Exception", e.errorMessage);
        toast.error(`Call Failed : ${e.errorMessage}`);
        debugLogs.current.push(
          `Call: Accpeting Call went into Exception, ${e.errorMessage}`
        );
      }
    }
  };

  const endCall = () => {
    /*
     * Disconnect an ongoing or initiated call
     */
    console.log("Call: End Action Triggered");
    debugLogs.current.push("Call: End Action Triggered");
    if (session.session) {
      try {
        if (session.incoming & session.ringing) {
          // When an incoming call is observed and the user wants to terminate
          console.log("Call: Rejected Initiated");
          toast.error("Call Rejected Initiated");
          debugLogs.current.push("Call: Rejected Initiated");
          session.session.rejectCall();
        } else {
          // When an call is ongoing either incoming or outgoing or outgoing call being made
          console.log("Call: DisconnectCall Initiated");
          toast.error("Call: DisconnectCall Initiated");
          debugLogs.current.push("Call: DisconnectCall Initiated");
          session.session.disconnectCall();
        }
      } catch (e) {
        console.log("Call: End Call went into Exception", e.errorMessage);
        toast.error(`Call Failed : ${e.errorMessage}`);
        debugLogs.current.push(
          `Call: End Call went into Exception, ${e.errorMessage}`
        );
      }
    }
  };

  const connect = (userName, userId) => {
    debugLogs.current.push(
      `Webclient version : ${process.env.REACT_APP_VERSION}`
    );
    debugLogs.current.push(
      `SDK version : ${window.EngageDigital?.getEngageDigitalVersion()}`
    );
    debugLogs.current.push("Triggered Connection");
    let engageDigital;
    try {
      setTimeToLoad(true);
      engageDigital = new window.EngageDigital.EngageDigitalClient(
        // localStorage.getItem("identity"),
        userId,
        window.config.domainName, // AWS Setup Required
        {
          log: {
            blob: { enable: true, emptyAfterRetrieval: true },
            console: { enable: true },
          },
          needRegistration: true,
          // userName: localStorage.getItem("username"),
          userName: userName,
          ...window.config.connectionOptionsOverride,
        }
      );
    } catch (error) {
      console.log("Error:", error.errorMessage);
      toast.error("Exception:" + error.errorMessage);
      setTimeToLoad(false);
    }
    engageRTCUtil.current = engageDigital.getEngageDigitalRTCUtils();
    setConnection({ ...connection, identity: userId, username: userName });
    // Store the connection object for reference.
    engageClient.current = engageDigital;

    //failed event handling
    engageDigital.addEventHandler("failed", (error) => {
      console.log("Failed Event Called");
      console.error("failed_event", error);
      setTimeToLoad(false);
      debugLogs.current.push(`Failed_event, ${error.errorMessage}`);
      toast.error(error.errorMessage);
    });

    engageDigital.addEventHandler("ready", () => {
      setReadyEvent(true);
      /*
       *   The Ready event is called as the SDK is initiatiazed successfully and is ready
       *   for operation. Ideally the first step taken is to call connect and register the
       *   the events
       */
      debugLogs.current.push("SDK-UI: Initialize Success");

      engageDigital.addEventHandler("errorinfo", (error) => {
        console.log("engageDegital - errorInfo:", error);
        toast.error(error.errorMessage);
        // Below code is for duplicate registration failed issue handling
        // if (error.errorCode === 16021) {
        //   setTimeout(() => {
        //     logoutClient();
        //     history.push("/");
        //   }, 3000);
        // }
      });

      engageDigital.addEventHandler("connecting", () => {
        /*
         *  Event is being called when connectivity is being established for the first time.
         */
        // if(session.session._autoanswer===false)
        setConnection({ ...connection, status: "Connecting" });
        debugLogs.current.push("Connection: Connecting");
        console.log("Connection: Connecting");
      });

      engageDigital.addEventHandler("connected", () => {
        /*
         *  Event is being called when connectivity is established for the first time.
         */
        setConnection({ ...connection, status: "Connected" });
        setTimeToLoad(false);
        debugLogs.current.push("Connection: Connected");
        console.log("Connection: Connected");
      });

      engageDigital.addEventHandler("disconnected", () => {
        /*
         *  Event is being called when connectivity is lost.
         */
        setConnection({ ...connection, status: "Disconnected" });
        debugLogs.current.push("Connection: Disconnected");
        console.log("Connection: Disconnected");
        onStopTranscribe()
      });

      engageDigital.addEventHandler("reconnecting", () => {
        /*
         *  Event is being called when connectivity is lost and the SDK tries to reconnect
         *  Note: The State of the connection will be connecting as we do not
         *  differentiate reconnecting/connecting in UI
         */
        setConnection({ ...connection, status: "Connecting" });
        debugLogs.current.push("Connection: Re-connecting");
        console.log("Connection: Re-connecting");
      });
      engageDigital.addEventHandler("reconnected", () => {
        /*
         *  Event is being called when connectivity is establish after an intermitent disconnection.
         *  Note: The state of the connection will be connected as we do not
         *  differentiate connected/reconnected
         */
        setConnection({ ...connection, status: "Connected" });
        debugLogs.current.push("Connection: Re-connected");
        console.log("Connection: Re-connected");
      });

      engageDigital.addEventHandler("newRTCSession", onSession);

      engageDigital.connect();
    });
  };

  useEffect(() => {
    /*
     *  The Use Effect is called once during the first render and
     *  handler is registered to act on back press or browser closure.
     */
    window.addEventListener("beforeunload", function (e) {
      e.preventDefault();
      e.returnValue = "Are you sure you want to close?";
    });
    window.addEventListener("unload", function (e) {
      logoutClient();
      e.preventDefault();
    });
  }, []);

  // To Load SDK
  useEffect(() => {
    if (timeToLoad) {
      let interval = null;
      interval = setInterval(() => {
        setTime((time) => time + 1);
      }, 1000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [timeToLoad]);

  useEffect(() => {
    if (!timeToLoad && time !== 0) {
      debugLogs.current.push(
        `Time taken to register: ${new Date(time * 1000)
          .toISOString()
          .substr(11, 8)}`
      );
      console.log(
        `[hh:mm:ss] Time taken to register : ${new Date(time * 1000)
          .toISOString()
          .substr(11, 8)}`
      );
    }
  }, [timeToLoad]);
  const { pathname } = useLocation();
  const onLayoutChange = (e) => {
    setConferenceLayout(e.target.checked);
  };

  const onStartTranscribe = () => {
    setToggleTranscribe(true);

    // axios
    //   .get(`http://localhost:5004/transcribeContent`)
    //   .then((response) => {
    //     document.getElementById("transcribeDrawer").innerHTML = response.data;
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
  };

  const onStopTranscribe = () => {
    setToggleTranscribe(false);
  };

  return (
    <div className="App">
      <ToastContainer />

      {test && (
        <div style={{ visibility: "hidden", display: "none" }}>
          <div
            style={{ visibility: "hidden" }}
            data-testid="connect_for_ut"
            onClick={() => connect("xyz", "xyz")}
          ></div>
          <div
            style={{ visibility: "hidden" }}
            data-testid="makecall_for_ut"
            onClick={() =>
              makeCall({ audio: true, video: true, remoteURI: "" })
            }
          ></div>
          <div
            style={{ visibility: "hidden" }}
            data-testid="acceptcall_for_ut"
            onClick={() => acceptCall("xyz", "xyz")}
          ></div>
          <div data-testid="logout_for_ut" onClick={() => logoutClient()}></div>
          <div data-testid="endcall_for_ut" onClick={() => endCall()}></div>
          <div
            style={{ visibility: "hidden" }}
            data-testid="connection_status_for_ut"
          >
            {connection.status}
          </div>
          <div
            style={{ visibility: "hidden" }}
            data-testid="incoming_call_for_ut"
          >
            {session.incoming ? "T" : "F"}
          </div>
          <div
            style={{ visibility: "hidden" }}
            data-testid="ringing_call_for_ut"
          >
            {session.ringing ? "T" : "F"}
          </div>
          <div
            style={{ visibility: "hidden" }}
            data-testid="ringing_message_for_ut"
            id="message"
          >
            ok
          </div>
          <div
            style={{ visibility: "hidden" }}
            data-testid="session_has_for_ut"
          >
            {session.session ? "T" : "F"}
          </div>
          <video
            style={{ visibility: "hidden" }}
            data-testid="remote_stream_for_ut"
            id="remoteStream"
          ></video>
          <video
            style={{ visibility: "hidden" }}
            data-testid="localstream_stream_for_ut"
            onClick={setLocalStreamHandler}
            id="localStream"
          ></video>
        </div>
      )}
      {pathname === "/" ? (
        <Login
          test={test}
          engageClient={engageClient.current}
          isLogged={isLogged}
          setIsLogged={setIsLogged}
          // loggedValue={loggedValue}
          // setLoggedValue={setLoggedValue}
          connect={connect}
          isBrowser={isBrowser}
          setIsBrowser={setIsBrowser}
        />
      ) : null}
      {pathname !== "/" ? (
        <Home
          setCollocation={setCollocation}
          collocation={collocation}
          readyEvent={readyEvent}
          engageClient={engageClient.current}
          remoteStream={remoteStream}
          localStream={localStream}
          upgrade={upgrade}
          setUpgrade={setUpgrade}
          RTCUtils={engageRTCUtil.current}
          debugLogs={debugLogs}
          connection={connection}
          session={session}
          makeCall={makeCall}
          acceptCall={acceptCall}
          endCall={endCall}
          connect={connect}
          remoteURI={remoteURI}
          setRemoteURI={setRemoteURI}
          logoutClient={logoutClient}
          resolutionData={resolutionData}
          test={test}
          conferenceLayout={conferenceLayout}
          setConferenceLayout={setConferenceLayout}
          onLayoutChange={onLayoutChange}
          setCallDate={setCallDate}
          onStartTranscribe={onStartTranscribe}
          onStopTranscribe={onStopTranscribe}
          toggleTranscribe={toggleTranscribe}
          setToggleTranscribe={setToggleTranscribe}
        />
      ) : null}
    </div>
  );
};
App.propTypes = {
  test: PropTypes.any,
};

export default App;
